import { postRequest } from '@/core';
import { globalAddresses } from '@/requests';

export default async function syncGlobalAddresses() {
	let url = globalAddresses.getSyncPath();
	try {
		let response = await postRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}